import { ApiPropertyOptional } from '@nestjs/swagger';
import { IsEmail, IsNotEmpty, IsPhoneNumber, IsString } from 'class-validator';

export class RegisterRequest {
  @ApiPropertyOptional({
    example: 'x@y.zzz',
    description: 'User email address',
  })
  @IsEmail()
  @IsNotEmpty()
  email: string;

  @ApiPropertyOptional({
    example: '12345678',
    description: 'User password',
  })
  @IsString()
  @IsNotEmpty()
  password: string;

  @ApiPropertyOptional({
    example: '+36701234567',
    description: 'User email phone',
  })
  @IsString()
  @IsNotEmpty()
  @IsPhoneNumber('HU')
  phone: string;

  @ApiPropertyOptional({
    example: 'John',
    description: 'User firstname',
  })
  @IsString()
  @IsNotEmpty()
  firstName: string;

  @ApiPropertyOptional({
    example: 'Smith',
    description: 'User lastname',
  })
  @IsString()
  @IsNotEmpty()
  lastName: string;

  constructor(
    email: string,
    password: string,
    phone: string,
    firstName: string,
    lastName: string
  ) {
    this.email = email;
    this.password = password;
    this.phone = phone;
    this.firstName = firstName;
    this.lastName = lastName;
  }
}
